import { MenuItem } from 'primeng/api';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { CompetitorsListFilterSelectorService, CompetitorsListFiltersEnum } from './competitors-list-filter-selector.service';
import { SettingsService } from 'src/app/services/settings.service';

@Component({
  selector: 'app-competitors-list-filter-selector',
  templateUrl: './competitors-list-filter-selector.component.html',
  styleUrls: ['./competitors-list-filter-selector.component.scss'],
})
export class CompetitorsListFilterSelectorComponent implements OnInit {
  @Output() filterSelected: EventEmitter<CompetitorsListFiltersEnum> = new EventEmitter();
  items: MenuItem[] = [];
  currentFilter: CompetitorsListFiltersEnum = CompetitorsListFiltersEnum.NO_FILTER
  label?: string 

  constructor(
    public appSettings: SettingsService,
    private competitorListFilterService: CompetitorsListFilterSelectorService
    ) {
      this.label = this.appSettings.getTranslate(CompetitorsListFiltersEnum.NO_FILTER)
  }

  ngOnInit() {
    this.buildDropDownMenu();
  }

  buildDropDownMenu() {
    const filters = this.competitorListFilterService.values;
    this.items = filters.map(filter=> {
      return {
        label: this.appSettings.getTranslate(filter),
        command: () => {
          this.emitSelectedFilter(filter)
        }
      }
    })
  }

  private emitSelectedFilter(filter: CompetitorsListFiltersEnum): void {
    this.filterSelected.emit(filter)
    this.competitorListFilterService.setSelectedCompetitorsListFilter(filter)
    this.currentFilter = filter
    this.label = this.appSettings.getTranslate(filter)
  }
}
